export default "__VITE_ASSET__CyxJL1Xr__"